var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.462 40.308v-34h18v8h19.077v26zm2-2h14v-6h-14zm0-8h14v-6h-14zm0-8h14v-6h-14zm0-8h14v-6h-14zm16 24h17.077v-22H23.462zm4.77-14v-2H35v2zm0 8v-2H35v2z"
  })));
};
export default SvgDocuments;